import {NoteItemList, Title, Note} from './styledComponents'

const NoteItem = props => {
  const {noteItem} = props
  const {title, notes} = noteItem

  return (
    <NoteItemList>
      <Title>{title}</Title>
      <Note>{notes}</Note>
    </NoteItemList>
  )
}
export default NoteItem
